import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;




// WEBPACK FOOTER //
// ./src/utils/eventBus.js